// extracted by mini-css-extract-plugin
module.exports = {"doc-page-wrapper":"D_cB container-lg d-flex p-3","doc-page":"D_cC","doc-page__title--enterprise":"D_cD","doc-page--with-side-menu":"D_cF","doc-page__title":"D_cG"};